
export const GET_PERSONAL_REQUEST = "GET_PERSONAL_REQUEST";
export const GET_PERSONAL_SUCCESS = "GET_PERSONAL_SUCCESS";
export const GET_PERSONAL_FAILURE = "GET_PERSONAL_FAILURE";



export const GET_PERSON_REQUEST = "GET_PERSON_REQUEST";
export const GET_PERSON_SUCCESS = "GET_PERSON_SUCCESS";
export const GET_PERSON_FAILURE = "GET_PERSON_FAILURE";